import { Button, Form, Input, Modal } from "antd";
import { updateAccountApi } from "api/account";
import { useNotificationContext } from "contexts/NotificationContext";
import { IAccount } from "models/account";
import { useState } from "react";

interface IProps {
  account: IAccount;
  open: boolean;
  handleClose: () => void;
  reload: () => void;
}

export default function ResetPasswordModal({
  account,
  open,
  handleClose,
  reload,
}: IProps) {
  const [loading, setLoading] = useState(false);
  const { showSuccess, showError } = useNotificationContext();
  const [form] = Form.useForm();

  const onFinish = async (values: any) => {
    setLoading(true);
    try {
      const { data, error } = await updateAccountApi(account.id, {
        first_name: account.first_name,
        last_name: account.last_name,
        email: account.email,
        phone: account.phone,
        role: account.role,
        password: values.password,
      });
      if (data) {
        showSuccess("Password reset successfully");
        form.resetFields();
        handleClose();
        reload();
      } else {
        showError(error?.message || "Failed to reset password");
      }
    } catch (err) {
      showError("An error occurred");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title={`Reset Password for ${account.first_name} ${account.last_name}`}
      open={open}
      onCancel={handleClose}
      footer={null}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        className="mt-4"
      >
        <Form.Item
          label="New Password"
          name="password"
          rules={[
            { required: true, message: "Please enter new password" },
            { min: 6, message: "Password must be at least 6 characters" },
          ]}
        >
          <Input.Password placeholder="Enter new password" />
        </Form.Item>

        <Form.Item
          label="Confirm Password"
          name="confirm"
          dependencies={["password"]}
          rules={[
            { required: true, message: "Please confirm password" },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue("password") === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error("Passwords do not match"));
              },
            }),
          ]}
        >
          <Input.Password placeholder="Confirm new password" />
        </Form.Item>

        <div className="flex justify-end gap-2 mt-6">
          <Button onClick={handleClose}>Cancel</Button>
          <Button type="primary" htmlType="submit" loading={loading} danger>
            Reset Password
          </Button>
        </div>
      </Form>
    </Modal>
  );
}
